import { parseValidDateString } from './common'

export const formatDay = (day) => {
  const date = new Date(day)
  const currentDate = new Date(date.getTime() + Math.abs((date.getTimezoneOffset() * 60000)))
  return parseValidDateString(`${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`)
}

export const getColByDay = (day, range) => {
  const date = new Date(day)
  let cols = {}
  for (let i = 0; i < range; i++) {
    if (i === 0) {
      cols[formatDay(date)] = 0
    }
    const nextDate = new Date(date.getDate() + 1)
    cols[formatDay(new Date(date.setDate(nextDate)).toJSON())] = 0
  }
  if (range === 0) {
    cols = {
      [formatDay(new Date(date).toJSON())]: 0
    }
  }
  return cols
}

export const formatyear = day => {
  const date = new Date(day)
  return `${date.getFullYear()}`
}

export const getColByYear = (day, range) => {
  const date = new Date(day)
  const cols = {}

  if (range === 0) {
    cols[formatyear(date)] = 0
  }

  for (let i = 0; i < range; i++) {
    if (i === 0) {
      cols[formatyear(date)] = 0
    }
    const nextYear = new Date(date.getFullYear() + 1)
    cols[formatyear(new Date(date.setFullYear(nextYear)).toJSON())] = 0
  }

  return cols
}

export const formatMonth = day => {
  const date = new Date(day)
  return `${date.getMonth() + 1}/${date.getFullYear()}`
}

export const getColByMonth = (day, range) => {
  const date = new Date(day)
  const cols = {}

  if (range === 0) {
    cols[formatMonth(date)] = 0
  }

  for (let i = 0; i < range; i++) {
    if (i === 0) {
      cols[formatMonth(date)] = 0
    }

    const nextMonth = date.getMonth() + 1
    date.setMonth(nextMonth)
    cols[formatMonth(date)] = 0
  }
  return cols
}

export const getNumberOfWeek = date => {
  const today = new Date(date)
  const firstDayOfYear = new Date(today.getFullYear(), 0, 1)
  const pastDaysOfYear = (today - firstDayOfYear) / 86400000
  return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7)
}

export const getColByWeek = (day, range) => {
  const date = new Date(day)
  const cols = {}
  if (range === 0) {
    cols[getNumberOfWeek(date)] = 0
  }

  for (let i = 0; i < range; i++) {
    if (i === 0) {
      cols[getNumberOfWeek(date)] = 0
    }
    date.setDate(date.getDate() + 7)
    cols[getNumberOfWeek(date)] = 0
  }
  return cols
}

export const convertLableExcel = date => {
  return new Date(date).toDateString()
}

export const getDateOfWeek = (startDay, week) => {
  const date = new Date(startDay)
  const day = 1 + (Number(week) - 1) * 7
  const currenDate = new Date(date.getFullYear(), 0, day)
  const firstDayOfWeeks = currenDate.getDate() - currenDate.getDay()
  const startDate = new Date(currenDate.setDate(firstDayOfWeeks))
  return startDate.toDateString()
}
